export default __webpack_public_path__ + "static/media/banner-01.88bb2dc9.jpg";